import { reverseMap } from "../../utils/map"
import { EffectEnum } from "./Effect"
import { Passive } from "./Passive"
import { Synergy } from "./Synergy"

export enum Weather {
  WINDY = "WINDY",
  NIGHT = "NIGHT",
  SANDSTORM = "SANDSTORM",
  ZENITH = "ZENITH",
  RAIN = "RAIN",
  SMOG = "SMOG",
  MISTY = "MISTY",
  DROUGHT = "DROUGHT",
  MURKY = "MURKY",
  BLOODMOON = "BLOODMOON",
  STORM = "STORM",
  SNOW = "SNOW",
  NEUTRAL = "NEUTRAL"
}

export const WeatherEffects: ReadonlyMap<Weather, EffectEnum> = new Map([
  [Weather.WINDY, EffectEnum.WINDY],
  [Weather.SNOW, EffectEnum.SNOW],
  [Weather.SMOG, EffectEnum.SMOG],
  [Weather.NIGHT, EffectEnum.NIGHT],
  [Weather.MISTY, EffectEnum.MISTY],
  [Weather.MURKY, EffectEnum.MURKY],
  [Weather.DROUGHT, EffectEnum.DROUGHT],
  [Weather.RAIN, EffectEnum.RAIN],
  [Weather.ZENITH, EffectEnum.ZENITH],
  [Weather.SANDSTORM, EffectEnum.SANDSTORM],
  [Weather.BLOODMOON, EffectEnum.BLOODMOON],
  [Weather.STORM, EffectEnum.STORM]
])

export const PassivesAssociatedToWeather: Map<Weather, Passive[]> = new Map([
  [Weather.RAIN, [Passive.RAIN]],
  [Weather.DROUGHT, [Passive.DROUGHT]],
  [Weather.ZENITH, [Passive.ZENITH]],
  [Weather.SANDSTORM, [Passive.SANDSTORM]],
  [Weather.MISTY, [Passive.MISTY]],
  [Weather.SNOW, [Passive.SNOW]],
  [Weather.STORM, [Passive.STORM]],
  [Weather.NIGHT, [Passive.NIGHT]],
  [Weather.WINDY, [Passive.WINDY]],
  [Weather.NEUTRAL, [Passive.AIRLOCK]]
])

export const WeatherAssociatedToSynergy: Map<Synergy, Weather> = new Map([
  [Synergy.GRASS, Weather.ZENITH],
  [Synergy.FIRE, Weather.DROUGHT],
  [Synergy.WATER, Weather.RAIN],
  [Synergy.GROUND, Weather.SANDSTORM],
  [Synergy.FAIRY, Weather.MISTY],
  [Synergy.ICE, Weather.SNOW],
  [Synergy.ELECTRIC, Weather.STORM],
  [Synergy.DARK, Weather.NIGHT],
  [Synergy.FLYING, Weather.WINDY],
  [Synergy.WILD, Weather.BLOODMOON],
  [Synergy.POISON, Weather.SMOG],
  [Synergy.GHOST, Weather.MURKY],
  [Synergy.NORMAL, Weather.NEUTRAL]
])

export const SynergyAssociatedToWeather = reverseMap(WeatherAssociatedToSynergy)
